import React, { useState, useContext } from "react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { BsCameraVideo, BsPlayCircleFill, BsPlus, BsX, BsChevronRight, BsThreeDotsVertical, BsStars } from "react-icons/bs";
import "../../../../assets/css/components/aiContent/VideoSection.css";

const VideoCard = ({ item, onPlay }) => (
  <div
    className="es-video-card"
    onClick={() => onPlay(item)}
    style={{ cursor: item.url ? "pointer" : "default" }}
  >
    <div className="es-video-thumb-wrap">
      {item.thumbnail ? (
        <img
          src={item.thumbnail}
          alt={item.name}
          className="es-video-thumb-img"
        />
      ) : (
        <div className="es-video-thumb-fallback" />
      )}

      <div className="es-video-thumb-overlay" />

      {item.duration && (
        <span className="es-video-duration-badge">{item.duration}</span>
      )}

      <span className="es-video-play-btn">
        <BsPlayCircleFill />
      </span>
    </div>

    <div className="es-video-card-footer">
      <div className="es-video-card-info">
        <p className="es-video-card-title">{item.name}</p>
        <span className="es-video-card-id">{item.id}</span>
      </div>
      <span className="es-video-card-menu">
        <BsThreeDotsVertical />
      </span>
    </div>
  </div>
);

const VideoSection = ({ items = [] }) => {
  const { baseUrl, selectedVoice, selectedAvatar } = useContext(AppContext);
  const [title, setTitle] = useState("");
  const [script, setScript] = useState("");
  const [loading, setLoading] = useState(false);
  const [playingVideo, setPlayingVideo] = useState(null);

  const createVideo = () => {
    setLoading(true);
    axios
      .post(`${baseUrl}/admin/esheygen/createvideo`, {
        avatar_id: selectedAvatar.id,
        voice_id: selectedAvatar.default_voice_id,
        title: title,
        script: script,
      })
      .then((res) => {
        console.log(res.data);
        alert("Video request submitted.");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const generatePrompt = () => {
    console.log("Generate Prompt button clicked");
    setLoading(true);

    axios
      .post(`${baseUrl}/admin/generate-script`, {
        title: title,
      })
      .then((response) => {
        console.log(response);
        setLoading(false);
        if (response.data.success) {
          setScript(response.data.script);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        console.log(error.response.data);
        alert(error.response.data.error.error.message);
      });
  };

  const handlePlay = (video) => {
    if (video.url) {
      setPlayingVideo(video);
    }
  };

  return (
    <div className="es-section-block es-video-block">
      <div className="es-section-header">
        <div className="es-section-title-group">
          <span className="es-section-icon-wrap es-icon-wrap-video">
            <BsCameraVideo />
          </span>
          <div>
            <h4 className="es-section-title">Videos</h4>
            <p className="es-section-desc">
              Create and manage AI-generated video content for your brand.
            </p>
          </div>
        </div>
        <BsChevronRight className="es-section-chevron" />
      </div>

      {/* Create New Video panel */}
      <div className="es-video-create-panel">
        <h5 className="es-video-create-title">Create New Video</h5>

        <div className="es-video-create-grid">
          <div className="es-video-create-col">
            <label className="es-video-field-label">Video Title</label>
            <input
              className="es-video-title-input"
              placeholder="Enter video title..."
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="es-video-create-col">
            <label className="es-video-field-label">Video Script</label>
            <textarea
              className="es-video-description-box"
              placeholder="Enter your video script..."
              rows={4}
              value={script}
              onChange={(e) => setScript(e.target.value)}
            />
          </div>
        </div>

        <div className="es-video-create-actions">
          <button
            className="es-btn-generate"
            onClick={generatePrompt}
            disabled={loading}
          >
            <BsStars /> {loading ? "Generating..." : "Generate Script"}
          </button>

          <button
            className="es-btn-create-video"
            onClick={createVideo}
            disabled={loading}
          >
            <BsPlus /> {loading ? "Creating..." : "Create Video"}
          </button>
        </div>
      </div>

      {/* Video library */}
      <div className="es-video-library-header">
        <h5 className="es-video-library-title">Video Library</h5>
        {items.length > 0 && (
          <span className="es-video-library-count">{items.length} videos</span>
        )}
      </div>

      {items.length === 0 ? (
        <div className="es-empty-state">No Video Found</div>
      ) : (
        <div className="es-video-grid">
          {items.map((item) => (
            <VideoCard key={item.id} item={item} onPlay={handlePlay} />
          ))}
        </div>
      )}

      {/* Video Player Modal */}
      {playingVideo && (
        <div
          onClick={() => setPlayingVideo(null)}
          className="es-video-modal-overlay"
        >
          <div onClick={(e) => e.stopPropagation()} className="es-video-modal-box">
            <button onClick={() => setPlayingVideo(null)} className="es-video-modal-close">
              <BsX />
            </button>
            <video src={playingVideo.url} controls autoPlay className="es-video-modal-player" />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSection;